import { z } from 'zod'

export const ClientProfileTabEnum = z.enum([
  'general-information',
  'activity',
  'keyless-access',
  'maintenance',
  'inspections',
  'packages',
  'visitors',
  'reservations',
  'amenities',
  'gift-cards',
])
export type ClientProfileTab = z.infer<typeof ClientProfileTabEnum>
